import { CardCase } from '@sbercloud/uikit-product-site-cards';
import { useRouter } from 'next/navigation';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';

interface CasesItemProps {
  link: string | null | number;
  title: string;
  categories: {
    id: string;
    slug: string;
    title: string;
  }[];
  image: string;
  rest: { companyName?: string; description?: string };
  pagePath: 'cases' | 'partners';
}

export function CasesItem({
  categories,
  title,
  link,
  image,
  rest,
  pagePath,
}: CasesItemProps) {
  const layoutType = useLayoutType();

  const imageSrc = image
    ? image
    : 'https://cdn.cloud.ru/backend/cases/cases_logo.svg?v=1';

  const href = `/${pagePath}/${link}`;
  const router = useRouter();
  const { clickAnalytics } = useAnalytics();

  return (
    <CardCase
      data-test-id={`cases-item-link-${title}`}
      href={href}
      title={rest.companyName || ''}
      tags={categories.map((category) => ({
        text: category.title,
        appearance: 'neutral',
      }))}
      description={title}
      logo={{
        src: imageSrc,
        alt: title,
      }}
      outline
      onClick={(e) => {
        e?.preventDefault();
        clickAnalytics({
          action: href,
          clickZone: 'body',
          clickElement: 'cardclick',
          clickContent: title,
          uniqueId: `cases-item-link-${title}`,
          transitionType: 'inside-link',
        });
        router.push(href);
      }}
      layoutType={layoutType}
    />
  );
}
